import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/testbed')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/testbed"!</div>
}
